import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Route, Router} from '@angular/router';
import {IRedirectApp} from '../../../domain/IRedirectApp';
import {CommonComponent} from '../common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {TranslateService} from '@ngx-translate/core';
// import {DialogService} from 'primeng-lts/dynamicdialog';
import {DialogService} from 'primeng/dynamicdialog';
import {environment} from '../../../../environments/environment';
import {Location} from '@angular/common';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent extends CommonComponent implements OnInit {
  allData: IRedirectApp = this.activatedRoute.snapshot.params;

  constructor(
    private activatedRoute: ActivatedRoute,
    router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private location: Location
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
    const pathParams: Params = this.activatedRoute.snapshot.params;
    const queryParams: Params = this.activatedRoute.snapshot.queryParams;

    if (pathParams?.data != null || queryParams?.referredCode != null) {
      this.router.navigate(['mobileApp/', pathParams?.data ?? queryParams?.referredCode], {queryParams});
    }
    if (pathParams?.data == null && queryParams?.referredCode == null && queryParams) {
      this.router.navigate(['mobileApp/'], {queryParams});
    }
  }
}
